import React, { useEffect, useRef } from 'react';
import './WhyUsSection.css';

const features = [
  { icon: 'fas fa-bolt',       title: 'Disciplined Investing Approach',   desc: 'Stay focused on long-term wealth creation with structured and consistent investing, avoiding emotional decisions.' },
  { icon: 'fas fa-shield-alt', title: 'Trusted & Transparent Execution',     desc: 'All investments are executed through regulated institutions with complete clarity at every step.' },
  { icon: 'fa-solid fa-chart-line', title: 'Market Insights & Awareness', desc: 'Access simplified market information and trends to better understand investment opportunities.' },
];

const statsCards = [
  { icon: 'fas fa-calendar-check',   number: '20+ Years', label: 'Experience' },
  { icon: 'fas fa-indian-rupee-sign', number: '₹100cr+',  label: 'Assets Under Management' },
  { icon: 'fas fa-users-gear',       number: '99%',       label: 'Client Satisfaction' },
  { icon: 'fas fa-medal',            number: '800+',      label: 'Happy Client' },
];

const WhyUsSection = () => {
  const leftRef  = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('show')),
      { threshold: 0.1 }
    );
    if (leftRef.current)  obs.observe(leftRef.current);
    if (rightRef.current) obs.observe(rightRef.current);
    return () => obs.disconnect();
  }, []);

  const onTilt = (e, card) => {
    const r = card.getBoundingClientRect();
    const rx = (e.clientY - r.top  - r.height / 2) / 20;
    const ry = (r.width  / 2 - (e.clientX - r.left)) / 20;
    card.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-10px) scale(1.05) translateZ(0)`;
  };

  const onTiltLeave = (e, card) => { card.style.transform = ''; };

  return (
    <section className="wc-ui-whyus-section" id="wc-ui-about">
      <div className="wc-ui-whyus-container">
        <div className="wc-ui-whyus-left wc-ui-reveal" ref={leftRef}>
          <h2 className="wc-ui-whyus-title">
            We're <span className="wc-ui-gradient-text">Not</span> Your <br />
            <span className="wc-ui-gradient-text">Typical</span> Investment Platform
          </h2>
          <div className="wc-ui-whyus-features">
            {features.map((f, i) => (
              <div className="wc-ui-whyus-feature" key={i}>
                <div className="wc-ui-whyus-feature-icon"><i className={f.icon}></i></div>
                <div className="wc-ui-whyus-feature-content">
                  <h3 className="wc-ui-whyus-feature-title">{f.title}</h3>
                  <p className="wc-ui-whyus-feature-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="wc-ui-whyus-right wc-ui-reveal" ref={rightRef}>
          <div className="wc-ui-whyus-stats-grid">
            {statsCards.map((s, i) => (
              <div
                key={i}
                className="wc-ui-whyus-stat-card"
                onMouseMove={(e) => onTilt(e, e.currentTarget)}
                onMouseLeave={(e) => onTiltLeave(e, e.currentTarget)}
              >
                <div className="wc-ui-whyus-stat-icon"><i className={s.icon}></i></div>
                <h3 className="wc-ui-whyus-stat-number">{s.number}</h3>
                <p className="wc-ui-whyus-stat-label">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
